<div class="item-wrap">
  <app-word-disp [word]="word"></app-word-disp>
  <app-word-play-btn [word]="word"></app-word-play-btn>
</div>
